<template>
  <div class="aq-order-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1>订单</h1>
    </div>

    <div class="content-area">

      <!-- 搜索框 -->
      <div class="search-section">
        <van-field
          v-model="searchName"
          placeholder="输入姓名搜索"
          left-icon="search"
          @input="onSearch"
        />
      </div>

      <!-- 状态过滤 -->
      <div class="filter-section">
        <div class="status-filters">
          <span
            :class="['status-link', { active: selectedStatus === 0 }]"
            @click="selectStatus(0)"
            @click.stop
          >
            全部
          </span>
          <span
            :class="['status-link', { active: selectedStatus === 1 }]"
            @click="selectStatus(1)"
            @click.stop
          >
            待交单
          </span>
          <span
            :class="['status-link', { active: selectedStatus === 2 }]"
            @click="selectStatus(2)"
            @click.stop
          >
            待审核
          </span>
          <span
            :class="['status-link', { active: selectedStatus === 3 }]"
            @click="selectStatus(3)"
            @click.stop
          >
            已完成
          </span>
          <span
            :class="['status-link', { active: selectedStatus === 4 }]"
            @click="selectStatus(4)"
            @click.stop
          >
            交单过期
          </span>
          <span
            :class="['status-link', { active: selectedStatus === 5 }]"
            @click="selectStatus(5)"
            @click.stop
          >
            审核未通过
          </span>
        </div>
      </div>

      <!-- 订单列表 -->
      <div class="order-list">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="order-item"
            v-for="item in orderList"
            :key="item.id || item.orderId"
          >
            <div class="order-info">
              <div class="order-name">姓名: {{ item.name }}</div>
              <div class="order-status">状态: {{ getStatusText(item.status) }}</div>
              <div class="order-time">创建时间: {{ formatDate(item.createTime) }}</div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
  </div>
</template>

<script>
import { orderList as orderListApi } from '@/api/aq'

export default {
  name: 'AqOrderList',
  data() {
    return {
      traderId: null,
      searchName: '',
      selectedStatus: 0, // 0表示全部状态
      orderList: [],
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      hasMore: true,
      isStatusChanging: false
    }
  },
  created() {
    // 从路由参数获取traderId
    this.traderId = this.$route.query.traderId || this.$route.params.traderId || this.$route.query.tradeId || this.$route.params.tradeId
    console.log('AqOrderList created, traderId:', this.traderId)
  },
  methods: {
    onSearch() {
      // 延迟搜索，避免频繁请求
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout(() => {
        this.resetList()
        this.loadOrderList()
      }, 500)
    },

    onLoad() {
      // 只有在不是状态切换且还有更多数据时才加载更多数据
      if (this.hasMore && !this.isStatusChanging) {
        this.loadOrderList()
      } else {
        this.finished = true
        this.loading = false
      }
    },

    selectStatus(status) {
      // 防止重复点击
      if (this.selectedStatus === status) {
        return
      }

      console.log('selectStatus called with:', status)
      // 设置状态切换标志
      this.isStatusChanging = true
      this.selectedStatus = status
      this.resetList()
      this.loadOrderList()

      // 状态切换完成后重置标志
      setTimeout(() => {
        this.isStatusChanging = false
      }, 300)
    },

    async loadOrderList() {
      console.log('loadOrderList called, page:', this.page)
      try {
        const params = {
          traderId: this.traderId,
          page: this.page,
          pageSize: this.pageSize
        }

        if (this.searchName) {
          params.name = this.searchName
        }

        if (this.selectedStatus !== 0) {
          params.status = this.selectedStatus
        }

        const response = await orderListApi(params)

        if (response && response.code === '200' && response.data) {
          const data = response.data
          this.orderList = this.orderList.concat(data.list || [])
          this.page++
          this.hasMore = data.hasMore || false

          if (!this.hasMore) {
            this.finished = true
          } else {
            // 确保在还有数据时finished为false
            this.finished = false
          }
        } else {
          // 如果请求失败，不要设置finished为true，这样可以继续尝试加载
          // this.finished = true
        }
      } catch (error) {
        console.error('获取订单列表失败:', error)
        this.finished = true
      } finally {
        this.loading = false
        // 确保状态切换标志被重置
        if (this.isStatusChanging) {
          setTimeout(() => {
            this.isStatusChanging = false
          }, 100)
        }
      }
    },

    resetList() {
      this.page = 1
      this.orderList = []
      this.finished = false
      this.hasMore = true
    },

    getStatusText(status) {
      const statusMap = {
        1: '待交单',
        2: '待审核',
        3: '已完成',
        4: '交单过期',
        5: '审核未通过'
      }
      return statusMap[status] || '未知状态'
    },

    formatDate(timestamp) {
      if (!timestamp) return ''
      const date = new Date(timestamp)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.aq-order-container {
  padding: 16px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 50px); /* 减去tabbar的高度 */
}

.page-header {
  background-color: white;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  text-align: center;
}

.page-header h1 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.content-area {
  background-color: white;
  padding: 16px;
  border-radius: 8px;
}

.search-section {
  margin-bottom: 10px;
  background-color: #f5f5f5;
  padding: 8px;
  border-radius: 8px;
}

/* 修改搜索框样式 */
.search-section /deep/ .van-field__control {
  border: 0; /* 边框为0 */
  border-radius: 4px;
}

.search-section /deep/ .van-field__left-icon {
  font-size: 20px; /* 增大图标 */
  color: #969799; /* 图标颜色 */
}

.filter-section {
  margin-bottom: 15px;
}

.status-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: flex-start;
}

.status-link {
  color: #666;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
  transition: color 0.3s;
}

.status-link:hover {
  color: #1989fa;
}

.status-link.active {
  color: #1989fa;
  font-weight: bold;
  background-color: #f0f9ff;
}

.order-list {
  margin-top: 10px;
}

.order-item {
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 8px;
  margin-bottom: 10px;
  background-color: #fafafa;
}

.order-info {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.order-name, .order-status, .order-time {
  font-size: 14px;
  color: #333;
}

.order-status {
  color: #1989fa;
  font-weight: bold;
}

.order-time {
  color: #999;
  font-size: 12px;
}
</style>
